import React from 'react';
import { Toast } from '@dbk/ui-notifications'
 
/* Toast message with a heading and description part to display errors/warnings */
const ErrorPopup = (props) => {
  const { header, message, onClose, containerStyle} = props;
  return (
     <div className="error-container" style={containerStyle}>
    <Toast underline status="error" onClose={() => onClose()}>
    
      <div className="toast-heading">{header}</div>
      <div className="toast-message">{message}</div>
    </Toast>
     </div>
      )
}
 
export default ErrorPopup; 